module.exports = __webpack_public_path__ + "img/white08_128.67092dc8.png";